export const ExperimentEnum = Object.freeze({

  // A1: [   // экран целей
  //   'A',  // нынешний
  //   'B',  // 1.4.3
  //   // 'C',  // 6 вариантов с текстом А
  //   // 'D',  // 6 вариантов с текстом B
  // ],
  //
  // A2: [   // имейл
  //   'A',  // с котиком
  //   'B',  // без котика
  // ],
  //
  // A3: [   // TOP APP
  //   'A',  // с баннером
  //   'B',  // без баннера
  // ],
  //
  // A4: [   // paywall кнопка + текст + таймер
  //   'A',  // с
  //   'B',  // без
  // ],
  //
  // A5: {
  //   'A': 50,  // rive и старые картинки
  //   'B': 50,  // новые картинки
  // },
  //
  // A6: [   // utm тексты на главной
  //   'A',  // поменяли
  //   'B',  // не меняли
  // ],
  //
  // A7: [
  //   'A',  // текущая версия
  //   'B',  // меняем картинки на первом экране возраста, убираем котика
  // ],
  //
  // A8: [
  //   'A',  // как есть
  //   'B',  // как есть, без прогреса
  //   'C',  // как есть + ачивка
  //   'D',  // как есть + тексты
  //   'E',  // все сразу
  // ],
  //
  // A9: [
  //   'A',  // текущая версия
  //   'B',  // новый график
  // ],
  //
  // A10: [
  //   'A',  // текущая версия
  //   'B',  // Science экран после цели 2 + добавить кастомизацию под цель (ток маскулинити)
  // ],
  //
  // A11: [
  //   'A',  // текущая версия
  //   'B',  // новый экран Age
  // ],
  //
  // A12: [
  //   'A',  // текущая версия
  //   'B',  // обновленный прелиминари процессинг
  // ],
  //
  // A13: [
  //   'A',  // текущая версия
  //   'B',  // 3 новых экрана сразу после Preliminary processing общие для всех веток
  // ],
  //
  // A14: [
  //   'A',  // текущая версия
  //   'B',  // +1 экран - Have you experienced any of these issues?
  // ],
  //
  // A15: [
  //   'A',  // текущая версия
  //   'B',  // переносим экраны
  // ],
  //
  // A16: [
  //   'A',  // текущая версия
  //   'B',  // новый блок на пейволе
  // ],
  //
  // A17: [
  //   'A',  // как сейчас без перебивки
  //   'B',  // темная тема
  //   // 'C',  // светлая тема
  // ],
  //
  // A18: [
  //   'A',  // none
  //   'B',  // EN_1
  //   'C',  // EN_2
  // ],
  //
  // A19: [
  //   'A',  // none
  //   'B',  // Based on more than 2 million downloads on the App Store and Google Play
  // ],
  //
  // A20: [
  //   'A',  // none
  //   'B',  // Now | In 3 months
  // ],
  //
  // A21: [
  //   'A',  // none
  //   'B',  // EN_1
  //   'C',  // EN_2
  // ],
  //
  // A22: [
  //   'A',  // none
  //   'B',  // Based on more than 2 million downloads on the App Store and Google Play
  // ],
  //
  // A23: [
  //   'A',  // none
  //   'B',  // Now | In 3 months
  // ],
  //
  // A24: {
  //   'A': 50,  // none
  //   'B': 50,  // Summarize
  // },
  //
  // A25: [
  //   'A',  // none
  //   'B',  // Online since 2021
  // ],
  //
  // A26: [
  //   'A',  // none
  //   'B',  // cookies
  // ],
  //
  // A27: [
  //   'A',  // This offer ends in
  //   'B',  // Once you close offer, it’s gone
  // ],
  //
  // A28: [
  //   'A',  // book
  //   'B',  // book2
  // ],
  //
  // A29: [
  //   'A',  // none
  //   'B',  // new images celebrity
  // ],
  //
  // A30: [
  //   'A',  // none
  //   'B',  // new timer
  // ],
  //
  // A31: [
  //   'A',  // none
  //   'B',  // new coach ava
  // ],
  //
  // A32: [
  //   'A',  // none
  //   'B',  // without promo
  // ],
  //
  // A33: [
  //   'A',  // none
  //   'B',  // new images celebrity for locale
  // ],
  //
  // A34: [
  //   'A',  // none
  //   'B',  // locale comments
  // ],
  //
  // A35: [
  //   'A',  // none
  //   'B',  // paywall support
  // ],
  //
  // A36: [
  //   'A',  // none
  //   'B',  // paywall halloween
  // ],
  //
  // A37: [
  //   'A',  // none
  //   'B',  // paywall plan localized
  // ],
  //
  // A38: [
  //   'A',  // none
  //   'B',  // localized listen
  // ],
  //
  // A39: [
  //   'A',  // with EN listen
  //   'B',  // without
  // ],
  //
  // A40: [
  //   'A',  // none
  //   'B',  // 3 months default
  // ],
  //
  // A41: [
  //   'A',  // none
  //   'B',  // bundle
  // ],
  //
  // A42: [
  //   'A',  // none
  //   'B',  // Improve your voice and communication
  // ],
  //
  // A43: [
  //   'A',  // none
  //   'B',  // new graph Science
  // ],
  //
  // A44: [
  //   'A',  // none
  //   'B',  // email autocomplete
  // ],
  //
  // A45: [
  //   'A',  // none
  //   'B',  // Start loving your voice
  // ],
  //
  // A46: [
  //   'A',  // none
  //   'B',  // Boost your communication skills
  //   'C',  // Communicate with confidence
  // ],
  //
  // A47: [
  //   'A',  // none
  //   'B',  // Emotional Intelligence
  // ],
  //
  // A48: [
  //   'A',  // none
  //   'B',  // date graph
  // ],
  //
  // A49: {
  //   'A': 70,  // none
  //   'B': 30,  // thick test
  // },
  //
  // A50: [
  //   'A',  // none
  //   'B',  // CookieYes
  // ],

  A51: [
    'A',  // ADHD
  ],

  // A52: [
  //   'A',  // none
  //   'B',  // currency localization
  // ],
  //
  // A53: [
  //   'A',  // none
  //   'B',  // short AI Coach
  // ],
  //
  // A54: [
  //   'A',  // none
  //   'B',  // new loading
  // ],
  //
  // A55: {
  //   'A': 95,  // none
  //   'B': 5,   // thick test
  // },
  //
  // A56: [
  //   'A',  // none
  //   'B',  // american address
  // ],
  //
  // A57: [
  //   'A',  // none
  //   'B',  // bonus toast on email page
  // ],
  //
  // A58: [
  //   'A',  // none
  //   'B',  // Email Entry
  // ],
  //
  // A59: [
  //   'A',  // none
  //   'B',  // new cookies
  // ],
  //
  // A60: [
  //   'A',  // none
  //   'B',  // new design of AI Coach
  // ],
  //
  // A61: { // India price
  //   'A': 60,  // none
  //   'B': 30,  // discount
  //   'C': 10,   // price
  // },
  //
  // A63: [
  //   'A',  // none
  //   'B',  // India light
  // ],
  //
  // A64: [
  //   'A',  // none
  //   'B',  // Flow update for ADHD campaign
  // ],
  //
  // A65: {
  //   'A': 60,  // none
  //   'B': 40,   // continue with Apple Pay buttons
  // },
  //
  // A66: [
  //   'A',  // none
  //   'B',  // new cookies
  //   'C',  // new cookies with reject
  // ],

  A68: [
    'A',  // none
    'B',  // new quiz design for interview
  ],

  // A69: [
  //   'A',  // none
  //   'B',  // Binary Gender Choice
  // ],
  //
  // A70: {
  //   'A': 60,   // none
  //   'B': 40,   // Multi-modal Paywall
  // },
  //
  // A71: [ // Headline update on Starting page
  //   'A',  // none
  //   // 'B',  // Learn to Speak so People Listen
  //   'C',  // Learn to Speak so People Listen — with AI Coach
  // ],
  //
  // A72: [
  //   'A',  // none
  //   'B',  // Update Processing Loader
  // ],
  //
  // A73: [ // New loading screen
  //   'A',  // none
  //   'B',  // Loader screen
  //   'C',  // Processing Loader
  // ],
  //
  // A75: [ // Bonus banner update on Email Entry
  //   'A',  // none
  //   'B',
  //   // 'C',
  //   // 'D',
  // ],
  //
  // A77: [
  //   'A',  // none
  //   'B',  // Bonus page
  // ],
  //
  // A78: [
  //   'A',  // none
  //   'B',  // Add Phone number to address
  // ],
  //
  // A79: [ // Cookie banner
  //   'A',  // none
  //   'B',
  //   'C',
  //   'D',
  // ],
  //
  // A80: [
  //   'A',  // none
  //   'B',  // Static images on Starting screen
  // ],
  //
  // A81: {
  //   'A': 60,   // none
  //   'B': 40,   // Set up Card as default payment option
  // },
  //
  // A82: [ // A70 → A
  //   'A',  // none
  //   'B',  // Video Before/ After on paywall
  // ],
  //
  // A83: [
  //   'A',  // none
  //   'B',  // Regional Social Proof
  // ],
  //
  // A84: [
  //   'A',  // none
  //   'B',  // Regional Social Proof
  // ],
  //
  // A85: {
  //   'A': 20,   // none
  //   'B': 80,   // Trust info update
  // },
  //
  // A86: [
  //   'A',  // none
  //   'B',  // Animated Start screen
  // ],
  //
  // A87: {
  //   'A': 60,   // none
  //   'B': 40,   // Discount animation on paywall
  //   // 'C': 60,   // 4 july
  // },
  //
  // A88: {
  //   'A': 20,  // none
  //   'B': 80,  // Independence Day Pricing section on Paywall
  // },
  //
  // A90: [
  //   'A',  // none
  //   'B',  // Address/ Phone section update
  // ],
  //
  // A92: [
  //   'A',  // none
  //   'B',  // Book1 & Bundle 1 redesign
  // ],
  //
  // A93: [
  //   'A',  // none
  //   'B',  // Audio Speech Test
  // ],
  //
  // A94: [
  //   'A',  // none
  //   'B',  // Animated Bonus Banner
  // ],
  //
  // A95: [
  //   'A',  // none
  //   'B',  // Before/After page Update
  // ],
  //
  // A97: { // Price section Redesign
  //   'A': 60,   // none
  //   // 'B': 10,
  //   'C': 40,
  //   // 'D': 10,
  // },
  //
  // A98: { // New Prices in US
  //   'A': 80,   // none
  //   'B': 5,
  //   'C': 5,
  //   'D': 5,
  //   'E': 5,
  // },
  //
  // AR98: { // New Prices (US)
  //   'A': 80,   // none
  //   'B': 20,
  // },
  //
  // // AA Test launch
  // AA1: ['A', 'B'],
  // AA2: {A: 60, B: 40},
  // AA3: {A: 70, B: 10, C: 10, D: 10},
  // AA4: {A: 80, B: 20},
  // AA5: ['A', 'B', 'C', 'D'],

})